import { range } from 'lodash';
import React from 'react';
import Table from '@splunk/dashboard-visualizations/Table';

export default () => (
    <Table
        options={{
            dataOverlayMode: 'heatmap',
        }}
        encoding={{
            columns: ['primary.income', 'primary.outcome'],
        }}
        dataSources={{
            primary: {
                requestParams: { offset: 0, count: 20 },
                data: {
                    fields: [{ name: 'income' }, { name: 'outcome' }],
                    columns: [range(10), range(10, 20)],
                },
                meta: { totalCount: 30 },
            },
        }}
    />
);
